import nl from "../locales/nl.json";
import en from "../locales/en.json";

const messages = { nl, en };

export function t(key, lang = "nl") {
  const keys = key.split(".");
  let value = messages[lang];
  for (const k of keys) {
    if (value && typeof value === "object") value = value[k];
    else return key;
  }
  return typeof value === "undefined" ? key : value;
}

export function getCurrentLang(settings) {
  return settings && settings.language ? settings.language : "nl";
}
